module.exports = __webpack_public_path__ + "img/step48.afde2ce3.png";